import type { SubjectOption } from './impact-of-disability_types'
import { getAreasOfNeed } from '@/presentlevels/api_v1.js'
import { useVisibilityStore } from '@/visibility/visibility.store'
import { storeToRefs } from 'pinia'

export function getIODSubjects(): SubjectOption[] {
  const { selVisibility } = storeToRefs(useVisibilityStore())
  return getAreasOfNeed({ iodSubject: true, selBlocked: !selVisibility.value })
}
